module.exports = __webpack_public_path__ + "static/media/moodle-selector.2edf31a5.svg";